import { Swiper, Navigation } from '@hh/global.js'

class HHMothershipCarousel extends HTMLElement {
  constructor() {
    super()
    this.mobileOnly = this.getAttribute('data-mobile-only') == 'true'

    this.device = window.innerWidth >= 750 ? 'desktop' : 'mobile'
    this.sliderInited = false

    Swiper.use([Navigation])
    if (this.mobileOnly) {
      this.toggleSlider()

      window.addEventListener('resize', () => {
        const device = window.innerWidth >= 750 ? 'desktop' : 'mobile'
        if (device != this.device) {
          this.device = device
          this.toggleSlider()
        }
      })
    } else {
      this.initSlider()
    }

    // Add the event listener for mouseover on elements with the class 'rec-card-wrapper'
    const recCardWrappers = this.querySelectorAll('.rec-img')
    recCardWrappers.forEach((element) => {
      element.addEventListener('mouseover', this.handleMouseover.bind(this))
    })
  }

  // Define the function to handle mouseover events
  handleMouseover(event) {
    // Get the value from the data-attribute 'data-some-value' on the hovered element
    const someValue = event.target.getAttribute('data-col-name')

    // Update the content of the div with the value
    const valueDiv = this.querySelector('.value-div') // Replace with the actual selector for your div
    valueDiv.textContent = someValue
  }

  toggleSlider() {
    if (this.device == 'mobile') {
      this.initSlider()
    } else if (this.sliderElement && this.sliderInited) {
      this.sliderElement.destroy(true, true)
    }
  }

  initSlider() {
    this.sliderElement = new Swiper(this.querySelector('.js-slider'), {
      slidesPerView: 'auto',
      initialSlide: 0,
      navigation: {
        nextEl: this.querySelector('.js-next'),
        prevEl: this.querySelector('.js-prev'),
      },
    })
    this.sliderInited = true
  }
}

customElements.define('hh-mothership-collection', HHMothershipCarousel)
